import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'

import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'
import TableAAPP from '../../Tables/TableAAPP'

const MarketStreeTransportCard = (props) => {
  const {
    transportTotal = [],
    gTotalT,
    selectedDate,
    totaTransportSegment = [],
    gTotalTA = [],
    gTotalTB,
  } = props
  const classes = useStyles()
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado TRANSPORTE</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA
              array={transportTotal}
              selectedDate={selectedDate}
              disableAA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución TRANSPORTE en miles</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                gTotalT,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP
              array={totaTransportSegment}
              param="SUBSEGMENTO"
              selectedDate={selectedDate}
              title="SUBSEGMENTO"
              AA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución TRANSPORTE por segmento año</h3>
            <br />
            <Bar
              id="12122"
              data={Utils.barLineDataGroup(gTotalTA, 'Y')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución TRANSPORTE por segmento mes</h3>
            <br />
            <Bar
              data={Utils.barLineDataGroup(gTotalTB, 'mes')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MarketStreeTransportCard
